export class OpenLROffsets {
  openlrPositiveOffset: number;
  openlrNegativeOffset?: number;
}



// WEBPACK FOOTER //
// ./src/app/models/openlr/openlroffsets.model.ts